import config from './webIMConfig'
import websdk from 'easemob-websdk'


// 初始化IM SDK
var WebIM = {}
WebIM = window.WebIM = websdk
WebIM.config = config

export default WebIM
